import sha256 from 'crypto-js/sha256'

import { Ref } from 'vue'
import { unixTime } from '@/modules/Geri'
import { split, update, join, compose, startsWith } from 'ramda'

function useCloudinaryMediaLibrary (reference: Ref<string>) {
	const cloud_name = 'fitravel'
	const timestamp  = unixTime()
	const username   = 'markadsdeild@uu.is'
	const api_key    = '634512946275931'
	const api_secret = '_clSiClQ4khoaY5VLqoslOXhdcQ'
	const signature  = generateSignature()
	const multiple   = false

	const options = { 
		cloud_name, api_key, username, timestamp, signature,
		multiple
	}

	function generateSignature () {
		const params = `cloud_name=${cloud_name}&timestamp=${timestamp}&username=${username}${api_secret}`
		return sha256(params)
	}
	function insertHandler (data: Data) {
		const { secure_url } = data?.assets?.[0] ?? {}
		const image = compose(join('/'), update(6, 't_tripchimp'), split('/'))(secure_url ?? '')
		
		reference.value = image
	}

	return window.cloudinary.createMediaLibrary(options, { insertHandler })
}

export default useCloudinaryMediaLibrary